<template>
  <div class="row">
    <div class="col-12">
      <h1>{{ msg }}</h1>
      <h4>Built config + server routing config ✔️</h4>
    </div>
    <div class="col-6">
      <router-link class="btn btn-primary" to="/">Home</router-link>
    </div>
    <div class="col-6">
      <router-link class="btn btn-primary" to="/about">Next</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}

</style>
